module.exports = __webpack_public_path__ + "bba4c94a09b1ab316b9ea1312e637fd5.jpg";